export enum MESSAGE_IMPORTANCE {
    INFO = 'INFO',
    ALERTE = 'ALERT',
    AVERTISSEMENT = 'WARN'
}
